<template>
<div class="cmap" :class="{'map-hide': !show, 'map-show': show }">
  <div id="cmap" :style="{height: mapHeight}"></div>
  <div class="audio-box" @click="playOrStopAudio" v-show="inNavigation">
    <img src="../../assets/stop-audio.png" alt="" v-if="!muted">
    <img src="../../assets/play-audio.png" alt="" v-else>
  </div>
  <!-- <div class="back" v-if="hideTab" @click="handleClick">
    <img src="../../assets/navigate/back.png" alt="">
  </div> -->
  <transition name="fade">
    <div class="suggest-info"
        v-if="type === 'suggest'"
        v-show="!inNavigation"
        :style="{bottom: list[activeIndex].meta.vehicle === 'foot' || list[activeIndex].meta.vehicle === 'car' ?  `${143 + offset}px` : `${136 + offset}px`}">{{ suggestInfo || $t('navigate.suggestInfo') }}</div>
    <div class="route-switcher"
         v-if="type !== 'suggest' && list.length > 1"
         v-show="!inNavigation"
         :style="{bottom: list[activeIndex].meta.vehicle === 'foot' || list[activeIndex].meta.vehicle === 'car' ? `${143 + offset}px` : `${136 + offset}px`}">
      <div class="route"
          :class="{'active': list[activeIndex].meta.weighting === 'fastest'}"
          @click="handleSelectRoute('fastest')">{{ $t('navigate.tagFastest') }}</div>
      <div class="route"
          :class="{'active': list[activeIndex].meta.weighting === 'foot_most_sheltered'}"
          @click="handleSelectRoute('foot_most_sheltered')">{{ $t('navigate.tagMostSheltered') }}</div>
    </div>
  </transition>
  <div class="start-container" v-show="inNavigation">
    <StartCom ref="startCom" />
    <div class="stop-navigate">
      <div class="stop-btn" @click="handleBack">
        <img src="../../assets/navigate/close.svg" />
        <span>{{ $t('navigate.exit') }}</span>
      </div>
      <div class="back-btn" @click="handleCurrent">{{ $t('navigate.backBtn') }}</div>
    </div>
  </div>
  <div class="current-marker" ref="marker">
    <div class="circle">
      <div class="arrow"></div>
    </div>
  </div>
  <!-- <div class="fake-location" ref="fakeMarker">
    <img src="/image/map/ShowItem.png" style="width: 24px; height: 24px;" />
  </div> -->
  <div class="current-locate" v-if="siteId === '1'" :class="{'in-navigation': inNavigation, 'web-locate': !currentEnv}" :style="{'margin-bottom': iphoneX ? `calc(${offset}px + 34px)` : `${offset + 40}px`}" @click="locateUser">
    <img src="../../assets/locator-sentosa-orange.svg" alt="" v-if="showLocateMarker">
    <img src="../../assets/locator-sentosa.svg" alt="" v-else>
  </div>
  <div class="current-locate" v-else :class="{'in-navigation': inNavigation}" :style="{'margin-bottom': iphoneX ? `calc(${offset}px + 34px)` : `${offset + 40}px`}" @click="locateUser">
    <img src="../../assets/zoom-in-orange.svg" alt="" v-if="showLocateMarker">
    <img src="../../assets/zoom-in.svg" alt="" v-else>
  </div>
</div>
</template>

<script>
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import StartCom from './StartCom'
import { calcDistance, distanceOfPoint2Line } from '@/utils'

export default {
  data () {
    return {
      muted: false,
      colorMap: {
        0: '#00aeef',
        1: '#ffa700',
        2: '#ffa700',
        3: '#ffa700',
        4: '#28752b',
        5: '#f15b67',
        6: '#5c2d91',
        7: '#006f9a'
      },
      show: true,
      list: [],
      type: '',
      suggestInfo: '',
      geoData: {},
      mapLoaded: false,
      stopRotate: false,
      alpha: '',
      mapTimer: '',
      showLocateMarker: false,
      currentEnv: null,
	  mapHeight: '100vh'
    }
  },
  computed: {
    siteId () {
      return this.$store.state.siteId
    },
  },
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    inNavigation: {
      type: Boolean,
      default: false
    },
    isUserAllowedGeoLocation: {
      type: Boolean,
      default: false
    },
    inThere: {
      type: Boolean,
      default: false
    },
    web: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 0
    },
    iphoneX: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StartCom
  },
  created () {
    const currentEnv = window.__wxjs_environment === 'miniprogram' || /miniProgram/i.test(navigator.userAgent.toLowerCase())
    this.currentEnv = currentEnv
    this.calculatedNextInstructionIndex = null
    this.audioPlayed = false
	if (this.$store.state.isSentaosaWeb) {
		this.mapHeight = '100%'
	}
  },
  beforeDestroy () {
    this.stopMapRotate()
  },
  mounted () {
    this.bearing = 0
    this.oldLayers = []
    mapboxgl.accessToken = 'pk.eyJ1IjoicHVzaGlhbiIsImEiOiJjaXdyaXptNDAweG1rMm90YmRnZHl0dDFpIn0.9kBN2eXNRe3uZ9VMoMhfhg'
    let center = [103.82740222, 1.2527583]
    let zoom = 12.6
    if (this.siteId === '245') {
      center = [103.820814, 1.255373]
      zoom = 14.5
    } else if (this.siteId === '129') {
      center = [103.861601, 1.340794]
      zoom = 9
    } else if (this.siteId === '33') {
      center = [10.372776, 51.083226]
      zoom = 5
    }

    this.map = new mapboxgl.Map({
      container: 'cmap',
      style: 'mapbox://styles/pushian/cj8313byya3lp2so6gvh49efn',
      center,
      zoom
    })

    // // Add geolocate control to the map.
    // this.geoControl = new mapboxgl.GeolocateControl({
    //   trackUserLocation: true
    // })

    // this.map.addControl(this.geoControl, 'bottom-left')

    this.map.on('load', () => {
      this.mapLoaded = true
    })

    this.map.on('dragstart', () => {
      if (this.inNavigation) {
        this.stopMapRotate()
      }
    })

    this.map.on('pitchstart', () => {
      this.stopRotate = true
    })

    this.map.on('pitchend', () => {
      if (this.inNavigation) {
        this.stopRotate = true
      }
    })

    this.map.on('rotate', res => {
      const alpha = this.map.getBearing()
      this.bearing = alpha
    })
  },
  methods: {
    playOrStopAudio () {
      this.muted = !this.muted
      this.$parent.$refs.audio.muted = !this.$parent.$refs.audio.muted
      // console.log(this.$parent.$refs.audio.muted)
      // if(this.$parent.isPlaying) {
      //   this.$parent.$refs.audio.muted = false
      // } else {
      //   this.$parent.$refs.audio.muted = true
      // }
    },
    stopMapRotate () {
      if (!this.stopRotate) {
        this.stopRotate = true
        this.map.setBearing(0)
      }
    },
    deviceOrientationHandler (alpha) {
      // console.log('收到的角度', alpha)
      if (!this.stopRotate && this.inNavigation) {
        this.map.setBearing(alpha)
        this.bearing = alpha
        const marker = document.querySelector('.current-marker .circle')
        // console.log('当前的marker', marker)
        marker.style.transform = 'rotateZ(0deg)'
      } else {
        // console.log('停止旋转')
        const marker = document.querySelector('.current-marker .circle')
        // console.log('当前的marker', marker)
        marker.style.transform = `rotateZ(${alpha - this.bearing}deg)`
      }
    },
    showMap (type, data, geoData) {
      this.show = true
      this.list = data
      this.type = type
      this.geoData = geoData
      if (type === 'suggest') {
        this.suggestInfo = data[0].meta.suggested_reason
      }
      if (this.mapLoaded) {
        console.log('绘制地图')
        this.drawRoutes(type, 0)
      } else {
        console.log('地图没有绘制完')
        this.mapTimer = setInterval(() => {
          if (this.mapLoaded) {
            this.drawRoutes(type, 0)
            clearInterval(this.mapTimer)
          }
        }, 1000)
      }
      // this.$nextTick(() => {
      //   const order = index || 0
      //   this.startIndex = order
      //   this.drawRoutes(type, order)
      // })
    },
    hideMap () {
      this.show = false
    },
    changeSlide (data) {
      this.drawRoutes(this.type, data)
    },
    handleSelectRoute (label) {
      const index = this.list.findIndex(item => item.meta.weighting === label)
      this.drawRoutes(this.type, index)
      this.$emit('change', index)
    },
    // 在地图上绘制路径
    drawRoutes (type, index) {
      // 清除旧的layer
      if (this.oldLayers.length > 0) {
        console.log('有旧的涂层')
        this.oldLayers.forEach(item => {
          this.map.removeLayer(item)
          this.map.removeSource(item)
        })
      }
      const listItem = this.list[index]
      let layers = []
      listItem.routeArray.forEach((route, order) => {
        const features = [{
          type: 'Feature',
          properties: {
            color: this.colorMap[route.type]
          },
          geometry: {
            type: 'LineString',
            coordinates: route.array.map(current => [current[0], current[1]])
          }
        }]
        const layerId = `lines-${type}-${index}-${order}`
        layers.push(layerId)
        const paint = {
          'line-width': 6,
          'line-color': ['get', 'color']
        }
        if (route.type === 0) {
          paint['line-dasharray'] = [0.6, 2]
        }
        this.map.addLayer({
          'id': layerId,
          'type': 'line',
          'source': {
            'type': 'geojson',
            'data': {
              'type': 'FeatureCollection',
              'features': features
            }
          },
          'layout': {
            'line-cap': 'round',
            'line-join': 'round'
          },
          'paint': paint
        })
      })
      this.oldLayers = layers
      const bbox = listItem.paths[0].bbox
      const bounds = new mapboxgl.LngLatBounds([bbox[0], bbox[1]], [bbox[2], bbox[3]])
      this.bounds = bounds
      this.map.fitBounds(bounds, {
        padding: {
          top: 190,
          bottom: 170 + this.offset,
          left: 60,
          right: 60
        },
        linear: true
      })
      this.drawMarker(index)
    },
    // 添加起点终点icon
    drawMarker (index) {
      // 清除旧的markers
      if (this.startMaker) {
        this.startMaker.remove()
      }
      if (this.endMarker) {
        this.endMarker.remove()
      }
      const listItem = this.list[index]
      listItem.meta.point.forEach((item, current) => {
        // create a DOM element for the marker
        const el = document.createElement('div')
        el.className = 'marker'
        if (current === 0) {
          // if (this.$i18n.locale === 'en') {
          //   el.style.backgroundImage = 'url(/image/navigate/start-en.png)'
          // } else {
          //   el.style.backgroundImage = 'url(/image/navigate/start.png)'
          // }
          el.style.backgroundImage = 'url(/image/navigate/start-marker.png)'
          el.style.width = '18px'
          el.style.height = '18px'


        } else {
          // if (this.$i18n.locale === 'en') {
          //   el.style.backgroundImage = 'url(/image/navigate/end-en.png)'
          // } else {
          //   el.style.backgroundImage = 'url(/image/navigate/end.png)'
          // }
          el.style.backgroundImage = 'url(/image/navigate/end-marker.png)'
          el.style.width = '18px'
          el.style.height = '27px'

        }
        el.style.backgroundSize = '100% 100%'
        el.style.backgroundPosition = 'center center'
               // add marker to map
        const marker = new mapboxgl.Marker(el)
          .setLngLat(item.split(',').reverse())
          .addTo(this.map)
        if (current === 0) {
          this.startMaker = marker
        } else {
          this.endMarker = marker
        }
      })
      // this.oldMarkers = markers
    },
    handleClick () {
      this.$emit('back')
    },
    // 开始导航
    startNavigate (geoData) {
      // console.log('cMap收到的geoData=======2', geoData)
      this.calculatedNextInstructionIndex = null
      this.audioPlayed = false
      this.updateStatus(geoData)
      this.map.panTo([geoData.lon, geoData.lat], { animate: false })
      this.map.setPitch(60)
      this.map.setZoom(18)
      this.stopRotate = false
      const marker = document.querySelector('.current-marker .circle')
      // console.log('当前的marker', marker)
      marker.style.transform = 'rotateZ(0deg)'
    },
    updateStatus (geoData, alpha) {
      // console.log('updateStatus收到的数据', geoData, alpha)
      if (geoData && geoData.lon) {
        this.geoData = geoData
        // console.log(this.list[this.activeIndex])
        if (this.inNavigation) {
          !this.stopRotate && this.map.panTo([geoData.lon, geoData.lat], { animate: false })
          this.getNearestPoint(geoData, this.list[this.activeIndex])
        }
        if (this.currentMarker) {
          this.currentMarker.setLngLat([geoData.lon, geoData.lat])
          this.currentMarker.addTo(this.map)
        } else {
          this.drawCurrentMarker(geoData.lon, geoData.lat)
        }
      }
      if (alpha) {
        this.alpha = alpha
        this.deviceOrientationHandler(alpha)
      }
    },
    getNearestPoint (geoData, route) {
      const instructions = route.paths[0].instructions
      let currentShortestDistance = null
      let calculatedNextInstructionIndex = -1
      let calculatedNextInstruction = {}
      let mappedPoint = {}
      for (let i = 0; i < instructions.length - 1; i++) {
        const result = distanceOfPoint2Line(geoData.lon, geoData.lat, instructions[i].first_lon, instructions[i].first_lat, instructions[i + 1].first_lon, instructions[i + 1].first_lat)
        // console.log('====result', result)
        if (currentShortestDistance === null || result.distance < currentShortestDistance) {
          currentShortestDistance = result.distance
          calculatedNextInstructionIndex = i + 1
          mappedPoint = {
            lon: result.lng,
            lat: result.lat,
            distance: result.distance
          }
        }
      }
      // 测试渲染mapped 点
      // if (this.fakeMarker) {
      //   this.fakeMarker.setLngLat([mappedPoint.lon, mappedPoint.lat])
      //   this.fakeMarker.addTo(this.map)
      // } else {
      //   const fakeMarker = new mapboxgl.Marker(this.$refs.fakeMarker)
      //     .setLngLat([mappedPoint.lon, mappedPoint.lat])
      //     .addTo(this.map)
      //   this.fakeMarker = fakeMarker
      // }
      if (this.currentMarker) {
        // console.log('当前位置的marker存在')
        this.currentMarker.setLngLat([this.geoData.lon, this.geoData.lat])
        this.currentMarker.addTo(this.map)
      }
      calculatedNextInstruction = instructions[calculatedNextInstructionIndex]

      // console.log('下一个instruction', calculatedNextInstruction)
      // 计算投影点到下一个指令点的距离
      const distanceToNextInstruction = calcDistance(mappedPoint.lat, mappedPoint.lon, calculatedNextInstruction.first_lat, calculatedNextInstruction.first_lon)
      // const distanceToLastInstruction = calcDistance(mappedPoint.lat, mappedPoint.lon, instructions[instructions.length - 1].first_lat, instructions[instructions.length - 1].first_lat)
      this.$refs.startCom.displayText({
        street_name: calculatedNextInstruction.street_name,
        text: calculatedNextInstruction.text,
        distance: distanceToNextInstruction
      })
      // console.log('=========================', calculatedNextInstructionIndex, this.calculatedNextInstructionIndex)
      // console.log(distanceToNextInstruction, this.audioPlayed)
      if (distanceToNextInstruction < 5 && !this.audioPlayed) {
        this.$emit('play', {
          street_name: calculatedNextInstruction.street_name,
          text: calculatedNextInstruction.text,
          distance: distanceToNextInstruction
        })
        this.audioPlayed = true
      } else if (calculatedNextInstructionIndex !== this.calculatedNextInstructionIndex) {
        this.$emit('play', {
          street_name: calculatedNextInstruction.street_name,
          text: calculatedNextInstruction.text,
          distance: distanceToNextInstruction
        })
        this.audioPlayed = false
      }
      this.calculatedNextInstructionIndex = calculatedNextInstructionIndex
    },
    // 添加当前位置marker
    drawCurrentMarker (longitude, latitude) {
      this.showLocateMarker = true
      // add marker to map
      const marker = new mapboxgl.Marker(this.$refs.marker)
        .setLngLat([longitude, latitude])
        .addTo(this.map)
      this.currentMarker = marker
    },
    handleBack () {
      this.map.setPitch(0)
      this.$emit('stop')
      this.stopMapRotate()
      // if (this.fakeMarker) {
      //   this.fakeMarker.remove()
      //   this.fakeMarker = null
      // }
      this.calculatedNextInstructionIndex = null
      this.audioPlayed = false // 小于5米时是否播放过语音
      console.log('退出导航后============', this.audioPlayed)
      this.map.fitBounds(this.bounds, {
        padding: {
          top: 190,
          bottom: 160,
          left: 60,
          right: 60
        },
        linear: true
      })
    },
    // 回到当前位置
    handleCurrent () {
      this.stopRotate = true
      this.map.panTo([this.geoData.lon, this.geoData.lat], { animate: false })
      this.map.setPitch(60)
      this.map.setZoom(18)
      this.stopRotate = false
      const marker = document.querySelector('.current-marker .circle')
      // console.log('当前的marker', marker)
      marker.style.transform = 'rotateZ(0deg)'
    },
    locateUser() {
      if (!this.isUserAllowedGeoLocation) {
        this.$createDialog({
          type: 'alert',
          confirmBtn: {
              text: this.$t('common.confirm')
          },
          content: this.$t('navigate.plzAllowLocation')
        }).show()
        return
      }
      if (!this.inThere) {
        let text = ''
        if (this.siteId === '245') {
          text = this.$t('navigate.notInRws')
        } else if (this.siteId === '129') {
          text = this.$t('navigate.notInSingapore')
        } else if (this.siteId === '33') {
          text = this.$t('navigate.notInGermany')
        } else {
          text = this.$t('navigate.notInSentosa')
        }
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: text
        })
        this.toast.show()
        return
      }
      if (this.geoData && this.geoData.lon) {
        if (!this.currentMarker) {
          this.drawCurrentMarker(this.geoData.lon, this.geoData.lat)
        }
        this.map.panTo([this.geoData.lon, this.geoData.lat])
      } else {
        this.toast = this.$createToast({
          time: 1500,
          type: 'txt',
          txt: this.$t('navigate.errorMsg')
        })
        this.toast.show()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#cmap {
  width: 100%;
  height: 100vh;
}

.cmap {
  width: 100%;
  height: 100vh;
  // position: relative;

  .back {
    position: absolute;
    top: 24px;
    left: 12px;

    img {
      width: 34px;
      height: 34px;
      display: block;
    }
  }
}

.suggest-info {
  position: absolute;
  bottom: 152px;
  left: 12px;
  max-width: 350px;
  background-color: #ffffff;
  height: 26px;
  border-radius: 4px;
  line-height: 26px;
  padding: 0 10px 0 9px;
  font-size: 12px;
  color: #222125;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: env(safe-area-inset-bottom);
}

.route-switcher {
  position: fixed;
  bottom: 122px;
  left: 12px;
  display: flex;
  align-items: center;
  padding: 0 2px;
  margin-bottom: env(safe-area-inset-bottom);

  .route {
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    font-size: 12px;
    color: #888888;
    background-color: #ffffff;
    position: relative;

    &.active {
      color: #ffa400;
    }

    &:first-child {
      border-radius: 4px 0 0 4px;
      &:after {
        content: '';
        width: 1px;
        height: 10px;
        background-color: #dddddd;
        top: 50%;
        margin-top: -5px;
        left: 100%;
        position: absolute;
        z-index: 2;
      }
    }

    &:last-child {
      border-radius: 0 4px 4px 0;
    }
  }
}

.stop-navigate {
  position: fixed;
  bottom: 11px;
  margin-bottom: env(safe-area-inset-bottom);
  width: calc(100% - 24px);
  left: 12px;
  z-index: 20;
  display: flex;
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 0 4px 0 rgba(19, 15, 3, 0.1);
}

.stop-btn {
  height: 42px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-left: 9px;

  img {
    width: 18px;
    display: block;
  }

  span {
    font-size: 16px;
    color: #222215;
    margin: 0 9px 0 3px;
  }
}
.back-btn {
  font-size: 16px;
  line-height: 42px;
  flex: 1;
  color: #ffa700;
  text-align: center;
  position: relative;

  &:before {
    content: '';
    width: 1px;
    height: 24px;
    position: absolute;
    top: 50%;
    left: 0;
    margin-top: -12px;
    background-color: #efefef;
  }
}

.audio-box {
  top: 20%;
  right: 20px;
  font-size: 16px;
  line-height: 42px;
  flex: 1;
  color: #ffa700;
  text-align: center;
  position: fixed;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 30;

  img {
    width: 19px;
    height: 19px;
    display: flex;
    justify-content: center;
    align-content: center;
  }
}

.current-locate {
  position: absolute;
  bottom: 200px;
  left: 12px;
  background-color: #ffffff;
  width: 38px;
  height: 38px;
  border-radius: 50%;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;

  &.web-locate {
    position: absolute;
    z-index: 999;
    right: 12px;
    left: auto;
    bottom: 124px;
  }

  &.in-navigation {
    display: none;
  }

  img {
    width: 26px;
    height: 26px;
    display: block;
  }
}
.current-marker {
  z-index: 20;
  .circle {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: url('/image/navigate/current-marker.svg') no-repeat center center;
    z-index: 2;
    position: relative;
    background-size: 100% 100%;
  }

  .arrow {
    position: absolute;
    border: 5px solid transparent;
    border-bottom: 5px solid #00AAE5;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    margin-bottom: -2px;
    // box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  }
}
</style>
